module.exports = __webpack_public_path__ + "static/media/ks_shack_background.cff0d556.jpg";